const state = {
    multAllowedSalesClass: null,
    multIndustries: null,
    multNaics3List: null,
    multNameList: null,
    multRemovedSalesClasses: null,
    multSalesClassNames: null,
    multSearch: null,
    multSearchesAllowed: null,
    multSearchesUsed: null,
    multSectors: null,
    multCurrentIndustry: null,
    multCount: null,
    multCurrentSalesClass: null,
    multSearchesResult: null,
};

const mutations = {
    MULT_SET_ALLOWED_SALES_CLASS: (state, multAllowedSalesClass) => {
        state.multAllowedSalesClass = multAllowedSalesClass;
    },
    MULT_SET_INDUSTRIES: (state, multIndustries) => {
        state.multIndustries = multIndustries;
    },
    MULT_SET_NAICS3LIST: (state, multNaics3List) => {
        state.multNaics3List = multNaics3List;
    },
    MULT_SET_NAME_LIST: (state, multNameList) => {
        state.multNameList = multNameList;
    },
    MULT_SET_REMOVED_SALES_CLASS: (state, multRemovedSalesClasses) => {
        state.multRemovedSalesClasses = multRemovedSalesClasses;
    },
    MULT_SET_SEARCH: (state, multSearch) => {
        state.multSearch = multSearch;
    },
    MULT_SET_SEARCHES_ALLOWED: (state, multSearchesAllowed) => {
        state.multSearchesAllowed = multSearchesAllowed;
    },
    MULT_SET_SEARCHES_USED: (state, multSearchesUsed) => {
        state.multSearchesUsed = multSearchesUsed;
    },
    MULT_SET_SECTORS: (state, multSectors) => {
        state.multSectors = multSectors;
    },
    MULT_SET_CURRENT_INDUSTRY: (state, multCurrentIndustry) => {
        state.multCurrentIndustry = multCurrentIndustry;
    },
    MULT_SET_COUNT: (state, multCount) => {
        state.multCount = multCount;
    },
    MULT_SET_CURRENT_SALES_CLASS: (state, multCurrentSalesClass) => {
        state.multCurrentSalesClass = multCurrentSalesClass;
    },
    MULT_SET_SEARCHES_RESULT: (state, multSearchesResult) => {
        state.multSearchesResult = multSearchesResult;
    },

};

const getters = {
    multAllowedSalesClass: (state) => state.multAllowedSalesClass,
    multIndustries: (state) => state.multIndustries,
    multNaics3List: (state) => state.multNaics3List,
    multNameList: (state) => state.multNameList,
    multRemovedSalesClasses: (state) => state.multRemovedSalesClasses,
    multSearch: (state) => state.multSearch,
    multSearchesAllowed: (state) => state.multSearchesAllowed,
    multSearchesUsed: (state) => state.multSearchesUsed,
    multSectors: (state) => state.multSectors,
    multCurrentIndustry: (state) => state.multCurrentIndustry,
    multCount: (state) => state.multCount,
    multCurrentSalesClass: (state) => state.multCurrentSalesClass,
    multSearchesResult: (state) => state.multSearchesResult,
};

const multiples = {
    state,
    getters,
    mutations,
};

export default multiples;